import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {RatingModule} from "@syncfusion/ej2-angular-inputs";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";

import {CheckBoxModule} from "@syncfusion/ej2-angular-buttons";
import {TranslatePipe} from "../../pipes/translate.pipe";

@Component({
    selector: 'app-form-rating',
    imports: [
        RatingModule,
        FormsModule,
        ReactiveFormsModule,
        CheckBoxModule,
        TranslatePipe
    ],
    templateUrl: './form-rating.component.html',
    styleUrl: './form-rating.component.scss'
})
export class FormRatingComponent implements OnChanges {
  @Input() public fCN: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public showLabel: boolean = false;
  @Input() public halfStep: boolean = false;
  @Input() public allowReset: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public errorText: string = '';


  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] && this.fG.controls[this.fCN]) {
      if (this.disabled) {
        this.fG.controls[this.fCN].disable();
      } else {
        this.fG.controls[this.fCN].enable();
      }
    }
  }
}
